import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DialogButton } from '../../../models/enums/dialogbutton.enum';
import { BaseDialog } from '../basedialog/base.dialog';

@Component({
    selector: 'url-dialog',
    templateUrl: './url.dialog.html',
    styleUrls: ['./url.dialog.css']
})
export class URLDialog {
    URL: any;

    static ShowDialog(url: string, title: string) {
        BaseDialog.ShowDialog({
            ContentType: URLDialog,
            InitArgs: {
                URL: url
            },
            Title: title,
            Buttons: DialogButton.Ok,
            HeightText: '100vh',
            WidthText: '100vw'
        });
    }

    constructor(private sanitizer: DomSanitizer) {
    }

    Initialize(args: any) {
        if (args && args.URL) {
            this.URL = this.sanitizer.bypassSecurityTrustResourceUrl(args.URL);
        }
    }
}